export default __webpack_public_path__ + "static/media/icon-sad-face-empty.c3f70f04.svg";